<script>
export default {
    sign_in_with: 'Anmelden mit',
    or_sign_in_with_credentials: 'Oder mit Zugangsdaten anmelden',
    sign_up_with: 'Registrieren mit',
    generic_error: 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.',
    i_agree_with_the: 'Ich stimme den ',
    we_have_sent_you_an_email: 'Wir haben Ihnen eine E-Mail gesendet :-)',
    email: 'E-Mail',
    password: 'Passwort',
    lost_your_password: 'Passwort vergessen?',
    recovery_here: 'hier wiederherstellen',
    sign_in: 'Anmelden',
    forgot_password: 'Passwort vergessen?',
    create_new_account: 'Neues Konto erstellen',
    terms_of_service: 'Nutzungsbedingungen',
    link_privacy: 'Datenschutzrichtlinie',
    term_conditions_text: 'Durch die Registrierung oder Anmeldung mit einem der oben genannten Dienste stimmen Sie unseren {link_terms} zu und erkennen unsere {link_privacy} an, die beschreibt, wie wir Ihre persönlichen Daten verwalten.',
    about_us: 'Über uns',
    blog: 'Blog',
    mit_license: 'MIT-Lizenz',
    docs: 'Dokumente',
    loading: 'Laden',
    dashboard: 'Dashboard',
    add_new_entry: 'Neuen Eintrag hinzufügen',
    add_new_model: 'Neues Modell hinzufügen',
    my_entries: 'Meine Einträge',
    search_entries: 'Einträge suchen',
    payee_list: 'Schuldnerliste',
    planned_entries: 'Geplante Einträge',
    budgets: 'Budgets',
    settings: 'Einstellungen',
    logout: 'Abmelden',
    expenses: 'Ausgaben',
    incoming: 'Einnahmen',
    transfer: 'Überweisung',
    debit: 'Schulden',
    choose_one_of_currently_tags: 'Wählen Sie einen der aktuellen Tags',
    choose_a_wallet_to_transfer_to: 'Wählen Sie eine Wallet zum Überweisen',
    choose_wallet_account: 'Wallet-Konto auswählen',
    choose_wallet_to_transfer: 'Wallet zum Überweisen auswählen',
    payment_confirg: 'Zahlung bestätigen',
    choose_an_option: 'Wählen Sie eine Option',
    choose_a_model: 'Modell auswählen',
    out_of_wallet: 'Aus der Wallet',
    insert_new_tag_name: 'Neuen TAG-Namen eingeben',
    add_here_your_note: 'Fügen Sie hier Ihre Notiz hinzu',
    insert_new_entry: 'Neuen Eintrag eingeben',
    show_planned_entries: 'Geplante Einträge anzeigen',
    show_more: 'Mehr anzeigen',
    restore: 'Wiederherstellen',
    reasume_of_all_entries: 'Zusammenfassung aller Einträge',
    list_of_all_payees: 'Liste aller Schuldner',
    forget_debit: 'Schuld vergessen',
    date_start: 'Startdatum',
    debit_name: 'Schuldname',
    date_end: 'Enddatum',
    choose_frequency: 'Frequenz auswählen',
    choose_method: 'Methode auswählen',
    insert_new_planned_entry: 'Neuen geplanten Eintrag eingeben',
    create_new_budget: 'Neues Budget erstellen',
    budget_name: 'Budgetname',
    period: 'Zeitraum',
    budget: 'Budget',
    account: 'Konto',
    category: 'Kategorie',
    label: 'Label',
    labels: 'Labels',
    entry_type: 'Eintragstyp',
    enable_email_notification: 'E-Mail-Benachrichtigung aktivieren',
    save_budget: 'Budget speichern',
    add_new_wallet: 'Neue Wallet hinzufügen',
    show_archived: 'Archivierte anzeigen',
    wallet_settings: 'Wallet-Einstellungen',
    category_settings: 'Kategorie-Einstellungen',
    add_new_category: 'Neue Kategorie hinzufügen',
    category_name: 'Kategoriename',
    save_changes: 'Änderungen speichern',
    archive_label: 'Label archivieren',
    add_model_entry: 'Neuen Modell-Eintrag hinzufügen',
    model_settings: 'Modelleinstellungen',
    set_your_default_currency: 'Standardwährung festlegen',
    currency_settings: 'Währungseinstellungen',
    wallets: 'Wallets',
    models: 'Modelle',
    categories: 'Kategorien',
    currency: 'Währung',
    profile: 'Profil',
    assistance: 'Hilfe',
    my_entry: 'Mein Eintrag',
    is_planned: 'Geplant',
    add: 'Hinzufügen',
    model: 'Modell',
    wallet: 'Wallet',
    payee: 'Empfänger',
    frequency: 'Frequenz',
    method: 'Methode',
    amount: 'Betrag',
    date: 'Datum',
    tag: 'Tag',
    tags: 'Tags',
    note: 'Notiz',
    save: 'Speichern',
    cancel: 'Abbrechen',
    close: 'Schließen',
    confirm: 'Bestätigen',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    show: 'Anzeigen',
    hide: 'Ausblenden',
    archive: 'Archivieren',
    unarchive: 'Wiederherstellen',
    search: 'Suchen',
    search_labels: 'Etiketten suchen...',
    or_insert_new_tag_name: 'Oder neuen Tag-Namen eingeben',
    show_details: 'Details anzeigen',
    bounce_rate: 'Absprungrate',
    session_duration: 'Sitzungsdauer',
    amount_before: 'Vorheriger Betrag',
    send_a_request: 'Anfrage senden',
    change_order: 'Reihenfolge ändern',
    add_new_workspace: 'Neuen Arbeitsbereich hinzufügen',
    set_up_your_workspaces: 'Arbeitsbereiche einrichten',
    choose_parent_category: 'Übergeordnete Kategorie auswählen',
    exclude_from_stats: 'Von Statistiken ausschließen',
    label_color: 'Label-Farbe',
    choose_currency: 'Währung auswählen',
    choose_wallet_type: 'Wallet-Typ auswählen',
    payment_deadline: 'Zahlungsfrist',
    credit_card_installment: 'Kreditkartenrate',
    wallet_color: 'Wallet-Farbe',
    workspace_settings: 'Arbeitsbereich-Einstellungen',
    default_currency: 'Standardwährung',
    default_payment_type: 'Standardzahlungstyp',
    share_workspace_with: 'Arbeitsbereich teilen mit',
    share: 'Teilen',
    remove: 'Entfernen',
    workspace_shared_with: 'Arbeitsbereich geteilt mit',
    choose_a_category: 'Kategorie auswählen',
    payment_confirm: 'Zahlung bestätigen',
    my_planned: 'Geplant',
    my_health: 'Finanzielle Gesundheit',
    workspace: 'Arbeitsbereich',
    entry_saved: 'Eintrag erfolgreich gespeichert',
    could_not_log_in: 'Anmeldung nicht möglich',
    send_my_password: 'Neues Passwort senden',
    recovery_your_password: 'Passwort wiederherstellen',
    name: 'Name',
    confirm_password: 'Passwort bestätigen',
    privacy_policy: 'Datenschutz & Richtlinie',
    create_account: 'Neues Konto erstellen',
    click_here: 'Hier klicken',
    save_template: 'Vorlage speichern',
    set_new_password: 'Neues Passwort festlegen',
    account_created: 'Konto erfolgreich erstellt, bitte bestätigen Sie Ihre E-Mail zur Aktivierung',
    search_by_text: 'Nach Text suchen',
    no: 'NEIN',
    yes: 'JA',
    date_interval: 'Datumsintervall',
    type_of_transaction: 'Transaktionstyp',
    choose_period: 'Zeitraum auswählen',
    daily: 'Täglich',
    weekly: 'Wöchentlich',
    monthly: 'Monatlich',
    yearly: 'Jährlich',
    one_shot: 'Einmalig',
    recursive: 'Wiederkehrend',
    or_nsert_new_tag_name: 'Oder neuen TAG-Namen eingeben',
    no_budgets_found: 'Keine Budgets gefunden',
    list_of_entries_of: 'Liste der Einträge von',
    no_payees_found: 'Keine Schuldner gefunden',
    list_of_all_budgets: 'Liste aller Budgets',
    list_of_all_planned_entries: 'Liste aller geplanten Einträge',
    set_your_default_currecny: 'Standardwährung festlegen',
    update: 'Aktualisieren',
    stats: 'Statistiken',
    payment_types: 'Zahlungsarten',
    create_new_debit: 'Neue Schuld erstellen',
    months: {
        jan: 'Jan',
        january: 'Januar',
        feb: 'Feb',
        february: 'Februar',
        mar: 'Mär',
        march: 'März',
        apr: 'Apr',
        april: 'April',
        may: 'Mai',
        jun: 'Jun',
        june: 'Juni',
        jul: 'Jul',
        july: 'Juli',
        aug: 'Aug',
        august: 'August',
        sep: 'Sep',
        september: 'September',
        oct: 'Okt',
        october: 'Oktober',
        nov: 'Nov',
        november: 'November',
        dec: 'Dez',
        december: 'Dezember',
    },
    closing_account_statement: 'Kontoabschluss',
    account_payment: 'Kontozahlung',
    start_date: 'Startdatum',
    end_date: 'Enddatum',
    show_entries: 'Einträge anzeigen',
    wallet_name: 'Wallet-Name',
    balance_wallet: 'Wallet-Saldo',
    wallet_type: 'Wallet-Typ',
    next_execution_time: 'Nächster Ausführungszeitpunkt',
    end_time: 'Endzeit',
    no_data_found: 'Keine Daten gefunden',
    average_incoming: 'Durchschnittliche Einnahmen',
    average_savings: 'Durchschnittliche Ersparnisse',
    your_planned_expenses: 'Geplante Ausgaben',
    average_expenses: 'Durchschnittliche Ausgaben',
    list_of_voices: 'Liste der Einträge',
    no_voices_found: 'Keine Einträge gefunden',
    workspace_whared_with: 'Arbeitsbereich geteilt mit',
    user_not_found: 'Benutzer nicht gefunden',
    save_as_model: 'Als Modell speichern',
    write_temlate_name: 'Modellnamen eingeben',
    end_of_month: 'Monatsende-Prognose',
    ticket_value: 'Gutscheinwert',
    spent: 'ausgegeben',
    remaining: 'verbleibend',
    planned: 'geplant',
    no_entries_found: 'Keine Einträge gefunden',
    credit_card_installement: 'Kreditkartenrate',
    choose_planned_type: 'Geplanten Typ auswählen',
    list_of_all_credit_cards: 'Liste aller Kreditkarten',
    details: 'Details',
    planned_entry: 'Geplant',
    back_to_login: 'Zurück zum Login',
    workspace_name: 'Name Ihres Arbeitsbereichs',
    first_wallet_name: 'Name Ihrer ersten Wallet',
    wallet_amount: 'Wallet-Saldo',
    setup_account: 'Konto einrichten',
    donate: 'Spenden',
    faq: 'FAQ',
    start_Date: 'Startdatum',
    savings: 'Ersparnisse',
    paid_debits: 'Schulden',
    given_on_loan: 'Verliehen',
    loans: 'Darlehen',
    goals: 'Ziele',
    list_of_all_goals: 'Liste aller Ziele',
    no_goals_found: 'Keine Ziele gefunden',
    add_new_goal: 'Neues Ziel hinzufügen',
    target_amount: 'Betrag',
    goal_name: 'Zielname',
    goal_target: 'Zieldatum',
    goal_note: 'Notizen',
    icons: {
        house: 'Haus',
        car: 'Auto',
        travel: 'Reise',
        education: 'Bildung',
        health: 'Gesundheit',
        savings: 'Ersparnisse',
        retirement: 'Ruhestand',
        business: 'Geschäft',
        charity: 'Wohltätigkeit',
        family: 'Familie',
        hobby: 'Hobby',
        investment: 'Investition',
        emergency: 'Notfall',
        vacation: 'Urlaub',
        home_improvement: 'Renovierung',
        technology: 'Technologie',
        pets: 'Haustiere',
        other: 'Andere',
    },
    goal_type: 'Zieltyp',
    activity: 'Aktivität',
    deposit: 'Einzahlung',
    saved: 'Gespart',
    my_goal: 'Mein Ziel',
    my_goals: 'Meine Ziele',
    current_saved: 'Aktuell gespart',
    monthly_deposit: 'Monatliche Einzahlung',
    due_date: 'Fälligkeitsdatum',
    description: 'Beschreibung',
    choose_a_goal: 'Ziel auswählen',
    withdrawal: 'Auszahlung',
    choose_payment_type: 'Zahlungsart auswählen',
    no_goals_available: 'Keine Ziele verfügbar',
    create_goal_to_start_saving: 'Erstellen Sie ein Ziel, um mit dem Sparen zu beginnen',
    create_first_goal: 'Erstellen Sie Ihr erstes Ziel',
    operation_type: 'Operationstyp',
    attention: 'Achtung',
    choose_payee: 'Empfänger auswählen',
    insert_payee_name: 'Empfängernamen eingeben',
    wallets_must_be_different: 'Wallets müssen unterschiedlich sein',
    create_goal_first: 'Erstellen Sie zuerst ein Ziel',
    label_input_hint: 'Sie können mehrere Labels durch Leerzeichen trennen',
    no_models_available: 'Keine Modelle verfügbar',
    create_first_model: 'Erstellen Sie Ihr erstes Modell',
    your_goal: 'Ihr Ziel',
    confirm_delete_goal: 'Löschen des Ziels bestätigen',
    remaining_expenses: 'Verbleibende Ausgaben',
    wallet_management: 'Wallet-Verwaltung',
    wallet_management_description: 'Verwalten Sie Ihre Wallets, fügen Sie neue hinzu und legen Sie Ihre Standard-Wallet fest.',
    add_first_wallet: 'Fügen Sie Ihre erste Wallet hinzu',
    no_wallets_available: 'Keine Wallets verfügbar',
    create_first_wallet: 'Erstellen Sie Ihre erste Wallet',
    archived: 'Archiviert',
    last_updated: 'Zuletzt aktualisiert',
    active_wallets: 'Aktive Wallets',
    all_wallets: 'Alle Wallets',
    archived_wallets: 'Archivierte Wallets',
    last_update: 'Letzte Aktualisierung',
    click_to_create_wallet: 'Klicken Sie, um eine Wallet zu erstellen',
    add_wallet: 'Wallet hinzufügen',
    credit_card_settings: 'Kreditkarten-Einstellungen',
    voucher_settings: 'Gutschein-Einstellungen',
    additional_options: 'Zusätzliche Optionen',
    enter_initial_balance: 'Anfangssaldo eingeben',
    edit_wallet: 'Wallet bearbeiten',
    initial_balance: 'Anfangssaldo',
    label_settings: 'Label-Einstellungen',
    manage_your_labels: 'Verwalten Sie Ihre Labels, fügen Sie neue hinzu oder archivieren Sie nicht verwendete',
    add_new_label: 'Neues Label hinzufügen',
    edit_label: 'Label bearbeiten',
    add_label: 'Label hinzufügen',
    label_name: 'Label-Name',
    active_labels: 'Aktive Labels',
    all_labels: 'Alle Labels',
    archived_labels: 'Archivierte Labels',
    no_labels_found: 'Keine Labels gefunden',
    balance: 'Saldo',
    active: 'Aktiv',
    manage_your_workspaces: 'Verwalten Sie Ihre Arbeitsbereiche',
    edit_workspace: 'Arbeitsbereich bearbeiten',
    user_shared: 'Benutzer geteilt',
    enter_email: 'E-Mail eingeben',
    no_workspaces_found: 'Keine Arbeitsbereiche gefunden',
    reset: 'Zurücksetzen',
    category_details: 'Kategoriedetails',
    expenses_by_category_monthly: 'Ausgaben nach Kategorie (monatlich)',
    expenses_by_category_comparison: 'Ausgaben nach Kategorie (Vergleich)',
    manage_your_models: 'Verwalten Sie Ihre Vorlagen, fügen Sie neue hinzu oder archivieren Sie ungenutzte',
    write_template_name: 'Vorlagenname eingeben',
    sort_name_asc: 'Name (A-Z)',
    sort_name_desc: 'Name (Z-A)',
    sort_amount_desc: 'Betrag (Hoch-Niedrig)',
    sort_amount_asc: 'Betrag (Niedrig-Hoch)',
    notification_emails: 'Benachrichtigungs-E-Mails',
    notification_thresholds: 'Benachrichtigungsschwellenwerte',
    notification_threshold_example: 'Z.B. 60 für 60%',
}
</script>